var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      ref: "details",
      attrs: {
        width: "66%",
        visible: _vm.visible,
        title: "详情",
        "append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.visible = $event
        },
      },
    },
    [
      _c(
        "el-descriptions",
        { attrs: { border: "", column: "2" } },
        [
          _c("el-descriptions-item", { attrs: { label: "活动名称" } }, [
            _vm._v(_vm._s(_vm.info.name)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动状态" } }, [
            _vm._v(_vm._s(_vm.info.status)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "创建人" } }, [
            _vm._v(_vm._s(_vm.info.createUserName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "创建时间" } }, [
            _vm._v(_vm._s(_vm.info.createTime)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动时间" } }, [
            _vm._v(
              _vm._s(_vm.info.startTime) + " 至 " + _vm._s(_vm.info.endTime)
            ),
          ]),
          _c("el-descriptions-item", { attrs: { label: "活动奖励" } }, [
            _vm._v(_vm._s(_vm.info.money)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "参与供应商" } }, [
            _vm._v(_vm._s(_vm.info.merchantName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "可用路线" } }, [
            _vm._v(_vm._s(_vm.info.lineName)),
          ]),
          _c("el-descriptions-item", { attrs: { label: "是否可使用优惠券" } }, [
            _vm._v(_vm._s(_vm.info.isChooseCoupon === 0 ? "否" : "是")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "互斥" } }, [
            _vm._v(_vm._s(_vm.info.isUserCoupon === 0 ? "是" : "否")),
          ]),
          _c("el-descriptions-item", { attrs: { label: "审核状态" } }, [
            _vm._v(_vm._s(_vm._f("stateFilter")(_vm.info.state))),
          ]),
          _c("el-descriptions-item", { attrs: { label: "审核人" } }, [
            _vm._v(_vm._s(_vm.info.auditorName)),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }